module.exports = __webpack_public_path__ + "static/media/helr45w_2.9977ffd9.woff";